/**
 * @generated SignedSource<<4ace922d92a4d91954ed2877f69143ae>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4

import type { ConcreteRequest } from 'relay-runtime';
export type ReactionsContentQuery$variables = {
  contentId: string;
};
export type ReactionsContentQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentReactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type ReactionsContentQuery = {
  response: ReactionsContentQuery$data;
  variables: ReactionsContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "ReactionsSummaryResponse",
            "kind": "LinkedField",
            "name": "contentReactionsSummary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "reactionsCount"
              },
              {
                "kind": "ScalarField",
                "name": "ari"
              },
              {
                "kind": "ScalarField",
                "name": "containerAri"
              },
              {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emojiId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "count"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "reacted"
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ReactionsContentQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReactionsContentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
    "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
    "metadata": {},
    "name": "ReactionsContentQuery",
    "operationKind": "query",
    "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
  }
};
})();

(node as any).hash = "324529dfd12ad8cfc9429a4857981e84";

export default node;
